import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HOME_SCROLL_KEY = 'kg-home-scroll';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/games/')) {
      window.scrollTo(0, 0);
      return;
    }

    if (pathname === '/') {
      const savedScroll = sessionStorage.getItem(HOME_SCROLL_KEY);
      if (savedScroll !== null) {
        requestAnimationFrame(() => {
          window.scrollTo(0, Number(savedScroll));
        });
      }
    }
  }, [pathname]);

  useEffect(() => {
    if (pathname !== '/') {
      return undefined;
    }

    const saveScroll = () => {
      sessionStorage.setItem(HOME_SCROLL_KEY, String(window.scrollY));
    };

    window.addEventListener('scroll', saveScroll, { passive: true });
    return () => {
      saveScroll();
      window.removeEventListener('scroll', saveScroll);
    };
  }, [pathname]);

  return null;
}

export default ScrollToTop;
